<template>
  <div class="fixed-width">
    <div class="card-body fluid"
      style="padding: 1rem !important; padding-bottom: 0 !important; padding-top: 0.75rem !important;">
      <!-- Layer name and close button -->
      <b-row class="text-black att-text pt-0 pb-1">
        <b-col class="d-flex justify-content-start align-items-center flex-row mb-1" cols="9">
          <span style="font-size: 22px">{{ layerName }} MetaData</span>
          <div class="download-border ml-3" @click="createReport">
            <fa :icon="['fas', 'download']" />
          </div>
        </b-col>
        <!-- <b-col cols="1" class="d-flex justify-content-center align-items-center mb-1">
          <div class="download-border" @click="createReport">
            <fa :icon="['fas', 'download']" />
          </div>
        </b-col> -->
        <b-col cols="3" class="d-flex justify-content-end align-items-center mb-2">
          <fa id="minOrMaxAttributeElement" class="float-right clickable mt-1 mx-1"
            :title="attributesMinimized ? 'Maximize Attributes' : 'Minimize Attributes'"
            :icon="['fas', attributesMinimized ? 'window-maximize' : 'window-minimize']"
            @click="$emit(attributesMinimized ? 'maximizeAttributes' : 'minimizeAttributes')" />
          <fa style="cursor: pointer" class="float-right mt-1" :icon="['fas', 'window-close']"
            @click="closeAnaAttTable()" />
        </b-col>
      </b-row>
      <div class="scrollable" v-show="!attributesMinimized">
        <!-- All attributes and their values -->
        <b-row 
          v-show="!attributesMinimized" 
          v-for="(resp, index) in anaAttribResponse.filter((resp) => resp.name != 'long' && resp.name != 'lat' && resp.name != 'coords' && resp.name != 'region')" 
          :key="index" 
          class="row py-1"
        >
          <b-col class="att-text capitalize" cols="4">{{ resp.name }}</b-col>
          <b-col :id="'editor' + index" cols="8" title="Copy Value" class="att-value blue" style="cursor: pointer"
            @click="copyText(resp.value)">
            {{ resp.value }}
          </b-col>
        </b-row>
        <hr v-show="!attributesMinimized">
        <b-row v-show="!attributesMinimized" class="mb-1" no-gutters>
          <b-col class="" style="font-size: 20px" cols="6">
            Minimum Distance
          </b-col>
          <!-- <b-col cols="1"></b-col> -->
          <b-col class="mb-1 d-flex justify-content-center align-items-center pl-4" 
                  style="font-size: 18px" cols="4" @click="calculateNearestDistance()">
            <!-- <u class="blue" style="cursor: pointer;">
              Calculate
            </u> -->
            <b-button class="calcBtn btn-sm">Calculate</b-button>
          </b-col>
          <b-col cols="2"></b-col>
        </b-row>
        <b-row style="height: 12px; font-size: 12px" class="mb-2 blue" no-gutters>
          <b-col cols="5" style="text-align: left;" class="pl-2">ROAD TYPE</b-col>
          <b-col cols="3" style="text-align: center;">DISTANCE</b-col>
          <b-col cols="4" style="text-align: center;">LON/LAT</b-col>
        </b-row>
        <b-row v-show="!attributesMinimized" class="nearestDistanceWindow" no-gutters>
          <b-col class="mb-1" cols="5">
            <b-row no-gutters v-for="(item, index) in items" :key="index">
              <label class="capitalize">
                <input type="checkbox" :value="item" v-model="selectedItems" />
                {{ item }}
              </label>
            </b-row>
          </b-col>
          <b-col cols="3" class="results-col">
            <b-row no-gutters>
              <div v-if="nearestDistances[0] && isAnaKilo" class="blue" @click="copyText(nearestDistances[0])">{{ nearestDistances[0] }} km</div>
              <div v-else-if="nearestDistances[0] && !isAnaKilo" class="blue" @click="copyText(nearestDistances[0])">{{ nearestDistances[0] }} miles</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-2" v-else-if="selectedItems.includes('motorway') && calculatingNearest">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="nearestDistances[1] && isAnaKilo" class="blue" @click="copyText(nearestDistances[1])">{{ nearestDistances[1] }} km</div>
              <div v-else-if="nearestDistances[1] && !isAnaKilo" class="blue" @click="copyText(nearestDistances[1])">{{ nearestDistances[1] }} miles</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-2" v-else-if="selectedItems.includes('trunk') && calculatingNearest">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="nearestDistances[2] && isAnaKilo" class="blue" @click="copyText(nearestDistances[2])">{{ nearestDistances[2] }} km</div>
              <div v-else-if="nearestDistances[2] && !isAnaKilo" class="blue" @click="copyText(nearestDistances[2])">{{ nearestDistances[2] }} miles</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-2" v-else-if="selectedItems.includes('primary') && calculatingNearest">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="nearestDistances[3] && isAnaKilo" class="blue" @click="copyText(nearestDistances[3])">{{ nearestDistances[3] }} km</div>
              <div v-else-if="nearestDistances[3] && !isAnaKilo" class="blue" @click="copyText(nearestDistances[3])">{{ nearestDistances[3] }} miles</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center align-items-center py-2" v-else-if="selectedItems.includes('secondary') && calculatingNearest">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
          </b-col>
          <b-col cols="4" class="mb-1 results-col">
            <b-row no-gutters>
              <div v-if="nearestSegments[0]" class="blue" @click="copyText(nearestSegments[0])">{{ nearestSegments[0] }}</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center py-2" v-else-if="selectedItems.includes('motorway') && calculatingNearest">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="nearestSegments[1]" class="blue" @click="copyText(nearestSegments[1])">{{ nearestSegments[1] }}</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center py-2" v-else-if="selectedItems.includes('trunk') && calculatingNearest">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="nearestSegments[2]" class="blue" @click="copyText(nearestSegments[2])">{{ nearestSegments[2] }}</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center py-2" v-else-if="selectedItems.includes('primary') && calculatingNearest">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="nearestSegments[3]" class="blue" @click="copyText(nearestSegments[3])">{{ nearestSegments[3] }}</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center py-2" v-else-if="selectedItems.includes('secondary') && calculatingNearest">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
          </b-col>
        </b-row>
        <hr v-show="!attributesMinimized">
        <b-row v-show="!attributesMinimized" class="mb-1" no-gutters>
          <b-col class="" style="font-size: 20px" cols="7">
            Total Distance
          </b-col>
        </b-row>
        <b-row style="height: 12px; font-size: 12px" class="mb-2 blue" no-gutters>
          <b-col cols="4" style="text-align: left;" class="pl-2">ROAD TYPE</b-col>
          <b-col cols="8" style="text-align: center;" class="pl-2">DISTANCE</b-col>
        </b-row>
        <b-row v-show="!attributesMinimized" class="totalDistanceWindow" no-gutters>
          <b-col class="mb-1" cols="4">
            <b-row no-gutters v-for="(item, index) in items" :key="index">
              <label class="capitalize">
                {{ item }}
              </label>
            </b-row>
          </b-col>
          <b-col cols="8" class="mb-1 results-col" style="padding-left: 1rem;">
            <b-row no-gutters>
              <div v-if="totalDistances[0] && isAnaKilo" class="blue" @click="copyText(totalDistances[0])">{{ totalDistances[0] }} km</div>
              <div v-else-if="totalDistances[0] && !isAnaKilo" class="blue" @click="copyText(totalDistances[0])">{{ totalDistances[0] }} miles</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center py-1" v-else-if="calculatingTotal">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="totalDistances[1] && isAnaKilo" class="blue" @click="copyText(totalDistances[1])">{{ totalDistances[1] }} km</div>
              <div v-else-if="totalDistances[1] && !isAnaKilo " class="blue" @click="copyText(totalDistances[1])">{{ totalDistances[1] }} miles</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center py-1" v-else-if="calculatingTotal">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="totalDistances[2] && isAnaKilo" class="blue" @click="copyText(totalDistances[2])">{{ totalDistances[2] }} km</div>
              <div v-else-if="totalDistances[2] && !isAnaKilo" class="blue" @click="copyText(totalDistances[2])">{{ totalDistances[2] }} miles</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center py-1" v-else-if="calculatingTotal">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
            <b-row no-gutters>
              <div v-if="totalDistances[3] && isAnaKilo" class="blue" @click="copyText(totalDistances[3])">{{ totalDistances[3] }} km</div>
              <div v-else-if="totalDistances[3] && !isAnaKilo" class="blue" @click="copyText(totalDistances[3])">{{ totalDistances[3] }} miles</div>
              <!-- Loading Spinner -->
              <div class="d-flex justify-content-center py-1" v-else-if="calculatingTotal">
                <span class="spinner-border spinner-border-sm blue" role="status" aria-hidden="true"></span>
              </div>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<style scoped>
.download-border {
  border: 2px solid black;
  background-color: rgb(0, 0, 0, 0.2);
  cursor: pointer;
  padding: 5px;
  color: black;
  border-radius: 10px;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.results-col .row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.results-col .row div {
  cursor: pointer;
}

.download-border:hover {
  border: 2px solid #063c6d !important;
  background-color: rgb(6, 60, 109, 0.3);
  opacity: 0.8;
  cursor: pointer;
  padding: 5px;
  color: #063c6d;
}

.capitalize {
  margin-left: 0 !important;
}

.blue {
  /* color: blue; */
  /* color: #008cff; */
  color: #063c6d;
}

.att-text {
  font-family: 'Inter Regular', sans-serif;
  opacity: 1 !important;
  white-space: initial !important;
  white-space: initial !important;
  word-wrap: break-word;
  text-overflow: ellipsis;
}

.att-value {
  font-family: 'Inter Regular', sans-serif;
  opacity: 1 !important;
  white-space: initial !important;
  word-wrap: break-word;
  text-overflow: ellipsis;
}

.vert-align {
  position: absolute;
  top: 50%;
  transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.fluid {
  max-width: 100%;
  height: 100%;
  border-radius: 15px;
  background-color: rgb(255, 255, 255, 0.9);
  border-radius: 0.25rem;
}

.fixed-width {
  max-width: 100%;
  width: 550px;
  height: 100%;
  padding-right: 20px;
}

.totalDistanceWindow .row {
  height: 35px !important;
}

.nearestDistanceWindow .row {
  height: 30px !important;
}

.nearestDistanceWindow label {
  margin: 0;
  margin-top: 2px;
  margin-left: 5px;
}

.calcBtn {
  background-color: #063c6d !important;
}

.calcBtn:hover {
  opacity: 0.8;
}

@media (max-width: 1700px) {
  .scrollable {
    max-height: 350px;
  }
}
</style>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
export default {
  name: 'MMP_Analytics_Attributes',
  props: [
    'attributesName',
    'attributesMinimized',
    'anaAttribResponse',
    'customerProjectId',
    'features',
    'feature_index',
    'map',
    'resetSequentialErrorButtons',
    'anaSliderVal',
    'isAnaKilo',
    'layerName'
  ],
  data() {
    return {
      currentErrorId: -1,
      disabledNext: false,
      disabledPrevious: false,
      errorFilters: '',
      index_item: null,
      names: null,
      items: ["motorway", "trunk", "primary", "secondary"], // Checkbox options
      selectedItems: [], // Selected values
      nearestDistances: [null, null, null, null],
      nearestSegments: [null, null, null, null],
      totalDistances: [null, null, null, null],
      calculatingNearest: false,
      calculatingTotal: false
    }
  },
  methods: {
    createReport() {
      let wb = XLSX.utils.book_new()

      // Meta Data
      let filtered = this.anaAttribResponse.filter(item => item.name != "coords")
      let metaHeaders = filtered.map(item => item.name)
      let metaData = filtered.map(item => item.value)
      let metaSheet = XLSX.utils.aoa_to_sheet([metaHeaders, metaData]);

      // Minimum Distances
      let minDistances = this.nearestDistances.map(dist => dist ? `${dist}${this.isAnaKilo ? 'km' : 'mi'}` : '')
      let minSheet = XLSX.utils.aoa_to_sheet([this.items, minDistances]); 

      // Total Distances
      let totalDist = this.totalDistances.map(dist => dist ? `${dist}${this.isAnaKilo ? 'km' : 'mi'}` : '')
      let totalSheet = XLSX.utils.aoa_to_sheet([this.items, totalDist]);

      // Write File
      XLSX.utils.book_append_sheet(wb, metaSheet, 'MetaData')
      XLSX.utils.book_append_sheet(wb, minSheet, 'Minimum Distances')
      XLSX.utils.book_append_sheet(wb, totalSheet, 'Total Distances')
      XLSX.writeFile(wb, `${this.layerName.replace(' ', '_')}_Report.xlsx`)
    },
    closeAnaAttTable() {
      this.$emit('closeAnaAttTable')
    },
    getNextFeature(modifier) {
      this.index_item = this.feature_index + modifier
      this.$emit('showNextAttribute', this.index_item)
    },
    copyText(attributeValue) {
      /* Writes value to user's clipboard and shows
      a toast that displays the copied data */
      if (String(attributeValue).includes('Z')) {
        // substring is contained in the string
        attributeValue = String(attributeValue).replace('Z', '')
      }

      //Remove Z if exists from all the dates showing up in attribute panel.
      navigator.clipboard.writeText(attributeValue)
      this.$bvToast.toast(attributeValue, {
        autoHideDelay: 7000,
        title: 'Copied Value To Clipboard',
        toaster: 'b-toaster-top-right'
      })
    },
    calculateNearestDistance() {
      let region = this.anaAttribResponse.filter((resp) => resp.name == 'region')[0].value
      let lat = this.anaAttribResponse.filter((resp) => resp.name == 'lat')[0].value
      let long = this.anaAttribResponse.filter((resp) => resp.name == 'long')[0].value
      let coords = [long, lat]
      this.nearestDistances = [null, null, null, null]
      this.nearestSegments = [null, null, null, null]
      if (this.selectedItems.length == 0) {
        return;
      }
      this.calculatingNearest = true
      let meters = this.isAnaKilo ? 1000 : 1609.34

      // Map OSM types to their respective functions
      const typeToFunctionMap = {
        motorway: () => this.calculateNearestMotorway(region, coords, meters),
        trunk: () => this.calculateNearestTrunk(region, coords, meters),
        primary: () => this.calculateNearestPrimary(region, coords, meters),
        secondary: () => this.calculateNearestSecondary(region, coords, meters)
      }

      // Build promises based on selectedItems
      const promises = this.selectedItems.map(type => typeToFunctionMap[type])
                          .filter(Boolean) // Remove any undefined (e.g., invalid osm_type)
                          .map(fn => fn()) // Call the function to get the promise
      
      Promise.all(promises).then(() => {
        this.calculatingNearest = false
      }).catch(error => {
        console.log('ERROR IN CALCULATING NEAREST DISTANCES: ' + error)
        this.nearestDistances = [null, null, null, null]
        this.nearestSegments = [null, null, null, null]
        this.calculatingNearest = false
      })
    },
    calculateNearestMotorway(region, coords, meters) {
      return new Promise((resolve, reject) => {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/analytics/calculateNearestMotorwayDistance/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  region: region,
                  coords: coords,
                  meters: meters
                }
              }
            )
            .then(response => {
              const content = response.data[0]
              if (content.errors) {
                console.log('calculateNearestMotorwayDistance API Call Error: ' + content.errors)
                reject(content.errors)
              } else {
                this.nearestDistances[0] = content.nearest_distance ? content.nearest_distance : null
                this.nearestSegments[0] = content.point ? content.point : null
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else {
          console.log('No User Token')
          reject('No User Token')
        }
      })
    },
    calculateNearestTrunk(region, coords, meters) {
      return new Promise((resolve, reject) => {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/analytics/calculateNearestTrunkDistance/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  region: region,
                  coords: coords,
                  meters: meters
                }
              }
            )
            .then(response => {
              const content = response.data[0]
              if (content.errors) {
                console.log('calculateNearestTrunkDistance API Call Error: ' + content.errors)
                reject(content.errors)
              } else {
                this.nearestDistances[1] = content.nearest_distance ? content.nearest_distance : null
                this.nearestSegments[1] = content.point ? content.point : null
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else {
          console.log('No User Token')
          reject('No User Token')
        }
      })
    },
    calculateNearestPrimary(region, coords, meters) {
      return new Promise((resolve, reject) => {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/analytics/calculateNearestPrimaryDistance/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  region: region,
                  coords: coords,
                  meters: meters
                }
              }
            )
            .then(response => {
              const content = response.data[0]
              if (content.errors) {
                console.log('calculateNearestPrimaryDistance API Call Error: ' + content.errors)
                reject(content.errors)
              } else {
                this.nearestDistances[2] = content.nearest_distance ? content.nearest_distance : null
                this.nearestSegments[2] = content.point ? content.point : null
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else {
          console.log('No User Token')
          reject('No User Token')
        }
      })
    },
    calculateNearestSecondary(region, coords, meters) {
      return new Promise((resolve, reject) => {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/analytics/calculateNearestSecondaryDistance/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  region: region,
                  coords: coords,
                  meters: meters
                }
              }
            )
            .then(response => {
              const content = response.data[0]
              if (content.errors) {
                console.log('calculateNearestSecondaryDistance API Call Error: ' + content.errors)
                reject(content.errors)
              } else {
                this.nearestDistances[3] = content.nearest_distance ? content.nearest_distance : null
                this.nearestSegments[3] = content.point ? content.point : null
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else {
          console.log('No User Token')
          reject('No User Token')
        }
      })
    },
    calculateTotalDistance() {
      let region = this.anaAttribResponse.filter((resp) => resp.name == 'region')[0].value
      let lat = this.anaAttribResponse.filter((resp) => resp.name == 'lat')[0].value
      let long = this.anaAttribResponse.filter((resp) => resp.name == 'long')[0].value
      let coords = [long, lat]
      this.totalDistances = [null, null, null, null]
      this.calculatingTotal = true 
      let meters = this.isAnaKilo ? 1000 * this.anaSliderVal : 1609.34 * this.anaSliderVal

      let promises = [
        this.calculateTotalMotorway(region, coords, meters),
        this.calculateTotalTrunk(region, coords, meters),
        this.calculateTotalPrimary(region, coords, meters),
        this.calculateTotalSecondary(region, coords, meters)
      ]
      
      Promise.all(promises).then(() => {
        this.calculatingTotal = false
      }).catch(error => {
        console.log('ERROR IN CALCULATING TOTAL DISTANCES: ' + error)
        this.totalDistances = [null, null, null, null]
        this.calculatingTotal = false
      })
    },
    calculateTotalMotorway(region, coords, meters) {
      return new Promise((resolve, reject) => {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/analytics/calculateTotalMotorwayDistance/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  region: region,
                  coords: coords,
                  meters: meters,
                  unit: this.isAnaKilo ? 1000 : 1609.34
                }
              }
            )
            .then(response => {
              const content = response.data[0]
              if (content.errors) {
                console.log('calculateTotalMotorwayDistance API Call Error: ' + content.errors)
              } else {
                this.totalDistances[0] = content.total_length ? content.total_length : null
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else {
          console.log('No User Token')
          reject('No User Token')
        }
      })
    },
    calculateTotalTrunk(region, coords, meters) {
      return new Promise((resolve, reject) => {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/analytics/calculateTotalTrunkDistance/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  region: region,
                  coords: coords,
                  meters: meters,
                  unit: this.isAnaKilo ? 1000 : 1609.34
                }
              }
            )
            .then(response => {
              const content = response.data[0]
              if (content.errors) {
                console.log('calculateTotalTrunkDistance API Call Error: ' + content.errors)
              } else {
                this.totalDistances[1] = content.total_length ? content.total_length : null
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else {
          console.log('No User Token')
          reject('No User Token')
        }
      })
    },
    calculateTotalPrimary(region, coords, meters) {
      return new Promise((resolve, reject) => {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/analytics/calculateTotalPrimaryDistance/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  region: region,
                  coords: coords,
                  meters: meters,
                  unit: this.isAnaKilo ? 1000 : 1609.34
                }
              }
            )
            .then(response => {
              const content = response.data[0]
              if (content.errors) {
                console.log('calculateTotalPrimaryDistance API Call Error: ' + content.errors)
              } else {
                this.totalDistances[2] = content.total_length ? content.total_length : null
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else {
          console.log('No User Token')
          reject('No User Token')
        }
      })
    },
    calculateTotalSecondary(region, coords, meters) {
      return new Promise((resolve, reject) => {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/analytics/calculateTotalSecondaryDistance/',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  region: region,
                  coords: coords,
                  meters: meters,
                  unit: this.isAnaKilo ? 1000 : 1609.34
                }
              }
            )
            .then(response => {
              const content = response.data[0]
              if (content.errors) {
                console.log('calculateTotalSecondaryDistance API Call Error: ' + content.errors)
              } else {
                this.totalDistances[3] = content.total_length ? content.total_length : null
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error)
              reject(error)
            })
        } else {
          console.log('No User Token')
          reject('No User Token')
        }
      })
    },
  },
  watch: {
    anaSliderVal: function (newValue) {
      if (this.anaAttribResponse) {
        this.calculateTotalDistance()
      }
    },
    anaAttribResponse: function (newValue) {
      if (newValue) {
        this.calculateNearestDistance()
        this.calculateTotalDistance()
      }
    },
    isAnaKilo: function (newValue) {
      this.isAnaKilo = newValue;
      if (this.anaAttribResponse) {
        this.nearestDistances = [null, null, null, null]
        this.nearestSegments = [null, null, null, null]
        this.selectedItems = []
      }
    }
  },
  mounted() {
    if (this.anaSliderVal) {
      this.calculateTotalDistance()
    }
  }
}
</script>
